import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../core/form/Table';
import Button from '../../../../core/form/Button';

const CanDoList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Locale',
        path: 'locale',
        sort: true,
        width: '80px',
        defaultSortOrder: 'ascend',
      },
      {
        label: 'Title',
        path: 'title',
      },
      {
        label: 'Description',
        path: 'description',
      },
      {
        label: 'Actions',
        path: 'action',
        width: '105px',
        render: (cell, row) => (
          <div>
            <Button icon="delete" onClick={() => props.onDelete(row)} />
          </div>
        ),
      },
    ]}
    rows={props.items}
  />
);

CanDoList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CanDoList;
